import { Alert, Platform } from "react-native";

type AlertButton = {
  text: string;
  style?: "default" | "cancel" | "destructive";
  onPress?: () => void;
};

export function alert(
  title: string,
  message?: string,
  buttons?: AlertButton[],
) {
  if (Platform.OS !== "web") {
    Alert.alert(title, message, buttons);
    return;
  }

  if (!buttons || buttons.length === 0) {
    window.alert(message ? `${title}\n${message}` : title);
    return;
  }

  const cancelButton = buttons.find((b) => b.style === "cancel");
  const actionButton = buttons.find((b) => b.style !== "cancel") ?? buttons[0];

  if (cancelButton && actionButton) {
    const confirmed = window.confirm(message ? `${title}\n${message}` : title);
    if (confirmed) {
      actionButton.onPress?.();
    } else {
      cancelButton.onPress?.();
    }
  } else {
    window.alert(message ? `${title}\n${message}` : title);
    buttons[0]?.onPress?.();
  }
}
